import type { CustomerRouter } from '@pelicargo/api';
import { createTRPCReact } from '@trpc/react-query';
import { inferRouterInputs, inferRouterOutputs } from '@trpc/server';

export type TrpcInputs = inferRouterInputs<CustomerRouter>;
export type TrpcOutputs = NonNullable<inferRouterOutputs<CustomerRouter>>;

export const trpc = createTRPCReact<CustomerRouter>();
